import { Route } from "react-router-dom";
import PrivacyPolicyPage from "../../modules/footer/presentation/pages/privacy_policy_page";
import TermsOfUsePage from "../../modules/footer/presentation/pages/terms_and_conditions_page";
import ReturnPolicyPage from "../../modules/footer/presentation/pages/return_policy_page";
import { AppRoutes } from "./app_routes";

const footerRoutes = [
  {
    path: AppRoutes.PRIVACY_POLICY,
    element: <PrivacyPolicyPage />,
  },
  {
    path: AppRoutes.TERMS_AND_CONDITIONS,
    element: <TermsOfUsePage />,
  },
  {
    path: AppRoutes.RETURN_POLICY,
    element: <ReturnPolicyPage />,
  },
];

export const footerRoutesBuilder = () => {
  return footerRoutes.map((route) => (
    <Route key={route.path} path={route.path} element={route.element} />
  ));
};
